import { cn } from "cn"
import type { LucideIcon } from "lucide-react"
import type { ReactNode } from "react"

/**
 * Shown where a list has nothing yet: what is missing and, when there is one, how to add it.
 * Pass only `children` for a one-line message.
 */
export function EmptyState({
  icon: Icon,
  title,
  action,
  className,
  children,
}: {
  icon?: LucideIcon
  title?: ReactNode
  action?: ReactNode
  className?: string
  children?: ReactNode
}) {
  return (
    <div className={cn("rounded-lg border border-dashed bg-surface-subtle p-6 text-sm", title || Icon ? "text-center" : "", className)}>
      {Icon && (
        <div className="mx-auto mb-3 flex size-10 items-center justify-center rounded-full bg-muted text-subtle-foreground">
          <Icon className="size-5" aria-hidden="true" />
        </div>
      )}
      {title && <p className="font-semibold">{title}</p>}
      {children && <div className={cn("text-muted-foreground", title && "mt-1")}>{children}</div>}
      {action && <div className="mt-4 flex justify-center gap-2">{action}</div>}
    </div>
  )
}
